import React, {useEffect} from 'react'

import {ROUTE_COMPANY_PROFILE} from '../../routes/constants'

type DummyRedirectPageProps = {
  redirect: (route: string) => void
}

const DummyRedirectPage: React.FC<DummyRedirectPageProps> = ({redirect}) => {
  useEffect(() => {
    redirect(ROUTE_COMPANY_PROFILE)
  }, [redirect])

  return null
}

export default DummyRedirectPage
